<template>
  <div class="login-container">
    <Card>
    <template #title>Вход в систему</template>
    <template #content>
        <form @submit.prevent="handleLogin" class="ModalLoginForm">
          <div class="field">
            <FloatLabel variant="on">
                <label for="username">Логин</label>
                <InputText
                    id="username" v-model="credentials.username" type="text"
                    :invalid="!credentials.username" autocomplete="username"/>
            </FloatLabel>
            <small v-if="errors.username" class="error-message">{{ errors.username }}</small>
          </div>
          <div class="field">
            <FloatLabel variant="on">
              <Password inputId="password" v-model="credentials.password" :feedback="false" toggleMask
               autocomplete="current-password" :invalid="!credentials.password"
              />
              <label for="password">Пароль</label>
            </FloatLabel>
            <small v-if="errors.password" class="error-message">{{ errors.password }}</small>
          </div>
          <Button
            type="submit"
            :label="'Войти'" :icon="`pi ${tryLogin?'pi-spin pi-spinner':'pi-chevron-right'}`" iconPos="right" :disabled="tryLogin"/>
        </form>
    </template>
  </Card>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useToast } from 'primevue/usetoast'
import { LoginService } from '@process/Login/login.service'

const toast = useToast()
const router = useRouter()

const loginService = new LoginService()


onMounted(async () => {
  const status = await loginService.tryLogin()
  console.log(status)
  if(status){
    router.push('/main')
  }
})


const credentials = reactive({
  username: '',
  password: ''
})

const errors = ref({
  username: '',
  password: ''
})
const tryLogin = ref(false)
const handleLogin = async () => {
  // Очищаем ошибки
  console.log("fdsfdsff")
  errors.value = { username: '', password: '' }
  
  // Валидация
  let hasError = false
  
  if (!credentials.username.trim()) {
    errors.value.username = 'Введите логин'
    hasError = true
  }
  
  if (!credentials.password) {
    errors.value.password = 'Введите пароль'
    hasError = true
  }
  
  if (hasError) return
  
  try {
    // Пытаемся войти
    tryLogin.value = true
    const responce = await loginService.login(credentials)
    toast.add({
      severity: 'success',
      summary: 'Успешный вход',
      detail: `Добро пожаловать, ${credentials.username}!`,
      life: 3000
    })
    tryLogin.value = false
    // Перенаправляем на запрошенную страницу или на дашборд
    router.push('/main')
    
  } catch (error) {
    tryLogin.value = false
    if(error.status == 403){
      toast.add({
        severity: 'error',
        summary: 'Ошибка входа',
        detail: 'В доступе отказано',
        life: 4000
      })
    } 
    else toast.add({
      severity: 'error',
      summary: 'Ошибка входа',
      detail: error.message,
      life: 4000
    })
  }
}

</script>

<style scoped>
.login-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 20px;
}

.p-card{
  height: 500px;
  width: 400px;
  margin: auto 50px;
}
#username{
  width: 100%;
}
.field{
  padding: 20px 0px;
}
:deep(.p-password) {
  width: 100%;
}
:deep(.p-password-input) {
  width: 100%;
}

.error-message {
  color: #ef4444;
  font-size: 12px;
}

</style>